var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"per-page-block"},[_c('DefaultSelect',{attrs:{"options":_vm.perPageVarsArray,"optionsLabel":'value',"clearable":false,"searchable":false,"selected":_vm.currentPerPage},on:{"change":_vm.changePerPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }